module.exports = __webpack_public_path__ + "img/logo.de917db9.png";